export abstract class BusinessObject {
	public id: number | null | undefined = null;
	public updatedDate: Date;

	constructor(busObj?: BusinessObject, holdAssign: boolean = false) {
		if (!holdAssign && busObj !== undefined && busObj != null) {
			this.assignObjects(busObj);
		}
	}

	protected assignObjects(busObj: BusinessObject) {
		Object.assign(this, busObj);

		const regexp = new RegExp(/(20|19)\d{2}(-|\/)((0[1-9])|(1[0-2]))(-|\/)((0[1-9])|([1-2][0-9])|(3[0-1]))(T|\s)(([0-1][0-9])|(2[0-3])):([0-5][0-9]):([0-5][0-9])/);

		for (const prop in this) {
			if (!!(<any>this)[prop]) {
				const stringProperty = (<any>this)[prop].toString();
				if (regexp.test(stringProperty) && Object.getOwnPropertyDescriptor(this, prop)) {
					(<any>this)[prop] = this.dateParse(stringProperty);
				}
			}
		}
	}

	public dateParse(dateString: string): Date {
		if (!dateString.endsWith('Z') && !dateString.includes('+', 15) && !dateString.includes('-', 15)) {
			dateString += 'Z';
		}

		return new Date(dateString);
	}
}
